import { render, staticRenderFns } from "./CloseModalIcon.vue?vue&type=template&id=401130d5&scoped=true"
import script from "./CloseModalIcon.vue?vue&type=script&lang=js"
export * from "./CloseModalIcon.vue?vue&type=script&lang=js"
import style0 from "./CloseModalIcon.vue?vue&type=style&index=0&id=401130d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401130d5",
  null
  
)

export default component.exports